<!--
     <ProcessDependingUserField
       :props="my_attrs_dictionary"
       @bind="my_bind_handler"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - id [REQUIRED] → This instance id.
     - process_field_id [REQUIRED] → The id of a process select to watch
     - permission_id [REQUIRED] → The permission_id, like "NCDEFAULT.evaluador"
     - multiple (default: false)
     - value
     - label
     - placeholder
-->

<template>
  <component
    v-bind:is="props.subcomponent"
    :ref="props.subcomponent_props.id"
    :id="props.subcomponent_props.id"
    :props="props.subcomponent_props"
    ></component>
</template>


<script>
import { mapGetters } from 'vuex'

import TextInput from '@/components/inputs/TextInput'
import DateInput from '@/components/inputs/DateInput'
import TextareaInput from '@/components/inputs/TextareaInput'
import NumericInput from '@/components/inputs/NumericInput'

export default {
  components: {
    TextInput,
    DateInput,
    TextareaInput,
    NumericInput,    
  },
  name: 'ComputedInput',

  props: ['props','form_values'],

  data: () => ({
    loading: false,
    root_field_id: '',
  }),

  computed: {
    ...mapGetters(['sitePath']),

    value() {
      return null
    },

    root_field_value() {
      return this.form_values[this.props.root_field_id];
    },
  },

  methods: {
    validate() {
      // TODO: Show error message
      return !this.props.required || !!this.$refs[this.props.id].validate && !this.$refs[this.props.id].validate()
    },

    error_state(ok) {
      this.valid = ok
    },

    update(value) {
      this.props.subcomponent_props.value = value;
      this.$emit('update',value);
    },
  },
  watch: {
    root_field_value(a,b) {
      if (a === b) {
         return;
      }
      this.update(this.root_field_value);
    }
  },
}
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>
